import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-delivery',
  templateUrl: 'delivery.component.html',
  imports: [RouterOutlet],
})
export class DeliveryComponent {}
